import type { ReactNode } from 'react';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
  action?: ReactNode;
}

export default function SectionHeading({ eyebrow, title, desc, align = 'left', action }: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div
      className={`flex flex-col gap-4 ${
        isCenter ? 'items-center text-center' : 'md:flex-row md:items-end md:justify-between'
      }`}
    >
      <div className={isCenter ? 'max-w-2xl' : 'max-w-2xl'}>
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-[0.18em] text-primary-600 uppercase">
            <span className="w-5 h-[2px] bg-primary-500 rounded-full" />
            {eyebrow}
          </span>
        )}
        <h2 className="mt-3 font-heading font-black text-2xl md:text-3xl text-foreground-950 leading-snug">{title}</h2>
        {desc && <p className="mt-3 text-sm md:text-base leading-7 text-foreground-600">{desc}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}